import { withInstall } from '../../utils/install';
import CarouselLoop from './index.vue';

export const IvueCarouselLoop = withInstall(CarouselLoop);
export default IvueCarouselLoop;

export * from './index.vue';
